import {
  Building,
  User,
  Menu,
  LayoutDashboard,
  Timer,
  FolderOpen,
  QrCode,
  BarChart3,
} from "lucide-react";

export interface SideBarItem {
  id: string;
  label: string;
  path: string;
  icon: React.ComponentType<{ size?: number; className?: string }>;
}

export const managerMenuItems: SideBarItem[] = [
  {
    id: "dashboard",
    label: "sidebar.dashboard",
    path: "/manager/dashboard",
    icon: LayoutDashboard,
  },
  {
    id: "menu",
    label: "sidebar.menuManagement",
    path: "/manager/menu",
    icon: Menu,
  },
  {
    id: "categories",
    label: "sidebar.manageCategories",
    path: "/manager/categories",
    icon: FolderOpen,
  },
  {
    id: "analytics",
    label: "sidebar.analytics",
    path: "/manager/analytics",
    icon: BarChart3,
  },
  {
    id: "qr-codes",
    label: "sidebar.qrCodeManagement",
    path: "/manager/qr-codes",
    icon: QrCode,
  },
  {
    id: "working-hours",
    label: "sidebar.workingHours",
    path: "/manager/working-hours",
    icon: Timer,
  },
  {
    id: "profile",
    label: "sidebar.profile",
    path: "/manager/profile",
    icon: User,
  },
];

export const adminMenuItems: SideBarItem[] = [
  {
    id: "dashboard",
    label: "sidebar.dashboard",
    path: "/admin/dashboard",
    icon: LayoutDashboard,
  },
  {
    id: "restaurants",
    label: "sidebar.manageRestaurants",
    path: "/admin/restaurants",
    icon: Building,
  },
  {
    id: "menu",
    label: "sidebar.manageMenu",
    path: "/admin/menu",
    icon: Menu,
  },
];
